<template>
  <section class="bg-co-gray-700">
    <div class="co-container-sm mx-auto px-4 py-7">
      <div class="flex flex-col items-center gap-y-4 text-co-gray-50 md:flex-row md:justify-center md:gap-x-8">
        <div class="w-full text-center md:w-2/12 md:text-left">
          <img
            class="mx-auto md:mx-0"
            src="~/assets/images/Te/TeCommon/Banner/Adobe/logo-adobe.svg"
            alt="Adobe社"
            width="124"
            height="147"
            loading="lazy"
          >
        </div>
        <div class="w-full">
          <h3 class="co-display-10 mb-5 text-center leading-base md:text-left">
            【37,140円相当】<br class="md:hidden">本格デザインツール3ヶ月分無償
          </h3>
          <p class="mb-4">
            デザインの代表的ツールであるPhotoshopを含むAdobe Creative Cloud コンプリートプランを3ヶ月分を無償提供いたします。
          </p>
          <p class="co-display-15 mb-0">
            ※3ヶ月を超えてご利用いただく場合は別途料金がかかります。<br>
            ※無償提供は日本国内でのみご利用いただけます。<br>
            ※テックアカデミーの他のコースではご利用いただけません。<br>
            ※クーポンの発行・ご利用は、お一人様一回までです。他コースでクーポンをご利用済みの場合は再度ご利用いただくことはできません。
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
